// Grouping for the External Resource Invoices list.
//
// The list arrives newest-submitted first and can run to hundreds of rows, so
// it is grouped into the month each invoice was submitted. A month whose
// invoices have all been paid is finished work and opens collapsed: the
// reviewer is only ever on that screen for the months that still need
// something doing to them.

const MONTHS = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];

// Dates come off D1 as 'YYYY-MM-DD HH:MM:SS' or 'YYYY-MM-DD'. Read the month
// out of the string rather than through Date, which would shift a date near a
// month boundary into the neighbouring month depending on the reader's offset.
function monthKey(value) {
  const m = /^(\d{4})-(\d{2})/.exec(String(value || '').trim());
  return m ? `${m[1]}-${m[2]}` : null;
}

function monthLabel(key) {
  const [year, month] = key.split('-');
  return `${MONTHS[Number(month) - 1]} ${year}`;
}

// `collapsePaid` is off when the reader has filtered the list to paid
// invoices: collapsing every month would leave them looking at nothing but
// headers, having just asked to see exactly those rows.
export function groupInvoicesByMonth(invoices, { collapsePaid = true } = {}) {
  const groups = [];
  const byKey = new Map();

  for (const inv of invoices || []) {
    // submitted_at is what the reviewer thinks of as the month; invoice_date
    // stands in for the rare row that predates it being recorded.
    const key = monthKey(inv.submitted_at) || monthKey(inv.invoice_date) || 'undated';
    let group = byKey.get(key);
    if (!group) {
      group = {
        key,
        label: key === 'undated' ? 'No date' : monthLabel(key),
        invoices: [],
        count: 0,
        total: 0,
        allPaid: true,
      };
      byKey.set(key, group);
      groups.push(group);
    }
    group.invoices.push(inv);
    group.count += 1;
    group.total += parseFloat(inv.total_amount) || 0;
    if (inv.status !== 'paid') group.allPaid = false;
  }

  // Undated rows sit at the end whatever order they arrived in; everything
  // else keeps the order the API returned, which is submitted-date descending.
  const undatedAtEnd = [
    ...groups.filter(g => g.key !== 'undated'),
    ...groups.filter(g => g.key === 'undated'),
  ];

  return undatedAtEnd.map(g => ({ ...g, defaultCollapsed: collapsePaid && g.allPaid }));
}
